import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function SyllabusChe() {
  return (
    <>

      <AllSubjectTopics icon="🗺️" subject="chemistry" type="syllabus" book="" />


    </>
  );
}

export default SyllabusChe;   